export const nameLengthValidator = (file: File) => {
    if (file && file.name && file.name.length > 200) {
      return {
        code: "name-too-large",
        message: `Name is larger than ${200} characters`
      };
    }
  
    return null
}
export class FileExtension {
    value: string;

    constructor(fileName: string) {
        this.value = fileName.split('.').pop()?.toLowerCase() || '';
    }

    isPdf(): boolean {
        return this.value === 'pdf';
    }

    isImage(): boolean {
        return ['png', 'jpg', 'jpeg'].includes(this.value);
    }
}

// Extend File interface with extension method
declare global {
    interface File {
        extension(): FileExtension;
    }
}

File.prototype.extension = function() {
    return new FileExtension(this.name);
};